import { createFileRoute } from '@tanstack/react-router'
import QuestionLib from '@/features/question-lib'

export const Route = createFileRoute('/_authenticated/question-lib/')({
  component: QuestionLib,
})
